import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import { RefreshCcw } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { SynchronizedType } from '../../order.types';

export const ORDER_INTEGRATION_STATUS_CHIP_CONFIG: Record<
  SynchronizedType,
  Omit<StatusChipProps, 'size'>
> = {
  [SynchronizedType.SUCCESS]: {
    label: LangEnum.ORDER_SYNC_STATUS_SUCCESS,
    icon: RefreshCcw,
    color: 'success',
  },
  [SynchronizedType.SUCCESS_RESET]: {
    label: LangEnum.ORDER_SYNC_STATUS_SUCCESS_RESET,
    icon: RefreshCcw,
    color: 'progress',
  },
  [SynchronizedType.SUCCESS_WITH_PAYMENT_ERROR]: {
    label: LangEnum.ORDER_SYNC_STATUS_SUCCESS_WITH_PAYMENT_ERROR,
    icon: RefreshCcw,
    color: 'waiting',
  },
  [SynchronizedType.ERROR]: {
    label: LangEnum.ORDER_SYNC_STATUS_ERROR,
    icon: RefreshCcw,
    color: 'error',
  },
  [SynchronizedType.PROCESSING]: {
    label: LangEnum.GLOBAL_INTEGRATION_PROCESSING,
    icon: RefreshCcw,
    color: 'progress',
  },
  [SynchronizedType.PROCESSING_AFTER_RESET]: {
    label: LangEnum.GLOBAL_INTEGRATION_PROCESSING,
    icon: RefreshCcw,
    color: 'progress',
  },
  [SynchronizedType.NOT_SYNCHRONIZED]: {
    label: LangEnum.ORDER_FILTER_NOT_SYNC_LABEL,
    icon: RefreshCcw,
    color: 'neutral',
  },
};
